<template>
  <div v-if="!loading">
    <div class="header-2">
      <div class="page-header header-filter">
        <div 
          :style="{backgroundImage: 'url(' + options.defaultAirport.backgroundImageUrl + ')'}"
          class="page-header-image" 
          style="background-image: url('img/bg-default.png')"/>
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto text-center">
                <h1 class="title">My Reservations</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center my-4">
        <div class="col-md-10">          
          <tabs pills>
            <tab-pane label="Booked">
              <div class="row align-items-center mb-3">
                <div class="col-auto">
                  Sort by Check Date
                </div>
                <div class="col-auto">
                  <el-select 
                    v-model="searchBookedReservation"
                    style="width: 120px"
                    placeholder="Select Option"
                    popper-class="el-popper-apc">
                    <el-option 
                      v-for="option in bookedReservationOptions"
                      :key="option.label"
                      :value="option.value"
                      :label="option.label" />
                  </el-select>
                </div>
              </div>
              <card 
                v-for="history in bookedReservations"
                :key="history.id">
                <h3 class="mt-0 mb-2">
                  {{ history.name }}
                </h3>
                <div class="row align-items-center">
                  <div class="col-md">
                    <div class="row align-items-center">
                      <div class="col-md-auto">
                        Check In:&nbsp;&nbsp;{{ formatter(history.startDate + ' ' + history.startTime) }}
                      </div>
                      <div class="col-md-auto">
                        Check Out:&nbsp;&nbsp;{{ formatter(history.endDate + ' ' + history.endTime) }}
                      </div>
                      <div class="col-md-auto">
                        Status:&nbsp;&nbsp;<span class="badge badge-pill badge-danger">{{ history.status && history.status.toUpperCase() }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-auto text-right">
                    <drop-down>
                      <n-button 
                        slot="title"
                        class="dropdown-toggle btn-block"
                        type="info"
                        data-toggle="dropdown"
                        round>
                        Actions
                      </n-button>
                      <a 
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="detail(history)">Detail</a>
                      <a 
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="getInstruction(history)">Instructions</a>
                      <a 
                        v-if="!history.canceled"
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="sendEmail(history.id)">Email Me Receipt</a>
                      <a 
                        v-if="history.canCancel"
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="cancelReservation(history.id)">Cancel Reservation</a>
                    </drop-down>
                  </div>
                </div>
              </card>
              <h4 
                v-if="!bookedReservations.length && !loading" 
                class="text-center">No booked reservations</h4>
            </tab-pane>
            <tab-pane label="All">              
              <div class="row align-items-center mb-3">
                <div class="col-auto">
                  Sort by
                </div>
                <div class="col-auto">
                  <el-select 
                    v-model="searchAll" 
                    placeholder="Select Option"
                    popper-class="el-popper-apc">
                    <el-option-group
                      v-for="group in allOptions"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                    </el-option-group>
                  </el-select>
                </div>
              </div>
              <card 
                v-for="history in histories"
                :key="history.id">
                <h3 class="mt-0 mb-2">
                  {{ history.name }}
                </h3>
                <div class="row align-items-center">
                  <div class="col-md">
                    <div class="row align-items-center">
                      <div class="col-md-auto">
                        Check In:&nbsp;&nbsp;{{ formatter(history.startDate + ' ' + history.startTime) }}
                      </div>
                      <div class="col-md-auto">
                        Check Out:&nbsp;&nbsp;{{ formatter(history.endDate + ' ' + history.endTime) }}
                      </div>
                      <div class="col-md-auto">
                        Status:&nbsp;&nbsp;<span class="badge badge-pill badge-danger">{{ history.status && history.status.toUpperCase() }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-auto text-right">
                    <drop-down>
                      <n-button 
                        slot="title"
                        class="dropdown-toggle btn-block"
                        type="info"
                        data-toggle="dropdown"
                        round>
                        Actions
                      </n-button>
                      <a 
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="detail(history)">Detail</a>
                      <a 
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="getInstruction(history)">Instructions</a>
                      <a 
                        v-if="!history.canceled"
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="sendEmail(history.id)">Email Me Receipt</a>
                      <a 
                        v-if="history.canCancel"
                        class="dropdown-item border-0" 
                        href="#"
                        @click.prevent="cancelReservation(history.id)">Cancel Reservation</a>
                    </drop-down>
                  </div>
                </div>
              </card>
              <h4 
                v-if="!histories.length && !loading" 
                class="text-center">No reservations</h4>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>

    <ReceiptModal
      :open="openReceiptModal"
      :data="receipt"
      @close="onCloseReceipt" />

    <InstructionsModal
      :open="openInstructionsModal"
      :data="instructions"
      @close="onCloseInstructions" />
      
    <WarningModal 
      :open="openWarningModal"
      :msg="'Canceling will terminate your reservation and refund you the amount paid Minus the $5.99 processing fee and one day of parking.'"
      :save-button-text="'Cancel Reservation'"
      @close="onCloseWarning" 
      @submit="onCanceledReservation" />
  </div>
</template>
<script>
  import moment from 'moment';
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Notification, Select, Option, OptionGroup } from 'element-ui';
  import { Button, Card, DropDown, Tabs, TabPane } from '@/components';
  import ReceiptModal from '@/pages/components/ReceiptModal.vue';
  import InstructionsModal from '@/pages/components/InstructionsModal.vue';
  import WarningModal from '@/pages/components/WarningModal.vue';

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [OptionGroup.name]: OptionGroup,
      Card,
      [Button.name]: Button,
      [DropDown.name]: DropDown,
      Tabs,
      TabPane,
      ReceiptModal,
      InstructionsModal,
      WarningModal
    },
    data() {
      return {
        searchBookedReservation: 'asc',
        bookedReservationOptions: [
          {
            label: 'ASC',
            value: 'asc'
          },
          {
            label: 'DESC',
            value: 'desc'
          }
        ],
        searchAll: 'date-asc',
        allOptions: [
          {
            label: 'Check Date',
            options: [
              {
                label: 'Check Date - ASC',
                value: 'date-asc'
              },
              {
                label: 'Check Date - DESC',
                value: 'date-desc'
              }
            ]
          },
          {
            label: 'Status',
            options: [
              {
                label: 'Status - ASC',
                value: 'status-asc'
              },
              {
                label: 'Status - DESC',
                value: 'status-desc'
              }
            ]
          }
        ],
        histories: [],
        openReceiptModal: false,
        receipt: null,
        instructionsId: null,
        openInstructionsModal: false,
        instructions: null,
        cancelId: null,
        openWarningModal: false
      };
    },
    computed: {
      ...mapState([
        'loading',
        'options'
      ]),
      bookedReservations() {
        return this.histories.filter(history => history.status === 'booked');
      }
    },
    watch: {
      searchBookedReservation() {
        this.bookedReservations = this.sortByDate(this.histories.filter(history => history.status === 'booked'), this.searchBookedReservation, 'startLocal');
      },
      searchAll() {
        if (this.searchAll.includes('date')) {
          this.histories = this.sortByDate(this.histories, this.searchAll, 'startLocal');
        } else if (this.searchAll.includes('status')) {
          this.histories = this.sortByStatus(this.histories, this.searchAll, 'status');
        }
      }
    },
    created() {
      this.getHistory();
    },
    methods: {
      ...mapMutations([
        'setLoading'
      ]),
      getHistory() {
        axios.get('reservation/member').then(res => {
          const { data } = res;
          console.log('reservation/member: ', data);
          this.histories = this.sortByDate(data, this.searchAll, 'startLocal');
          this.setLoading(false);
        }).catch(err => {
          console.error('reservation/member: ', err.response);
          this.setLoading(false);
        })
      },
      formatter(date) {
        return moment(date).format('MM/DD/YYYY hh:mm A');
      },
      detail(history) {
        this.receipt = history;
        this.openReceiptModal = true;
      },
      onCloseReceipt() {
        this.openReceiptModal = false;
        this.receipt = null;
      },
      cancelReservation(id) {
        this.cancelId = id;
        this.openWarningModal=true;
      },
      onCanceledReservation() {
        axios.get(`reservation/cancel?id=${this.cancelId}`).then(res => {
          const { data } = res;
          const id = this.histories.findIndex(x => x.id === data.id);
          this.histories[id] = data;
          this.histories = this.histories.concat();
          this.cancelId = null;
          this.openWarningModal=false;
          Notification({
            type: 'success',
            title: 'Success',
            message: 'Your reservation was successfully canceled and you should see a refund to your card in the next 1-7 business days based on your banks policy. Additionally you should receive a receipt of cancelation in your email.',
            customClass: 'alert-success',
            offset: 80,
            showClose: false,
          });
        }).catch(err => {
          console.error('reservation: ', err);
          this.openWarningModal=false;
          const { data } = err.response;
          Notification({
            type: 'error',
            title: 'Failed',
            message: data.responseStatus.message,
            customClass: 'alert-error',
            offset: 80,
            showClose: false,
          });
        })
      },
      onCloseWarning() {
        this.cancelId = null;
        this.openWarningModal = false;
      },
      getInstruction(history) {
        this.instructionsId = history.id;
        axios.get(`reservation/instructions?reservationId=${this.instructionsId}`).then(res => {
          const { data } = res;
          console.log('reservation/instructions: ', data);
          this.instructions = {
            name: history.name,
            sections: data
          };
          this.openInstructionsModal = true;
          this.instructionsId = null;
        })
      },
      onCloseInstructions() {
        this.openInstructionsModal = false;
        this.instructions = null;
      },
      sendEmail(id) {
        axios.post(`reservation/receipt`, {reservationId: id}).then(res => {
          const { data } = res;
          console.log('reservation/receipt: ', data);
          let customClass = '', title = '', message = '';
          if (data) {
            customClass = 'alert-success';
            title = 'Success';
            message = 'Receipt was sent';
          } else {
            customClass = 'alert-danger';
            title = 'Error';
            message = 'Receipt doesn\'t sent';
          }
          Notification({
            type: data ? 'success' : 'danger',
            title: title,
            message: message,
            customClass: customClass,
            offset: 80,
            showClose: false,
          });
        })
      },
      sortByDate(arr, dir, key) {
        if (dir.includes('asc')) {
          return arr.sort((a, b) => {
            const aDate = new Date(a[key]);
            const bDate = new Date(b[key]);
            return aDate > bDate ? 1 : (bDate > aDate ? -1 : 0);
          });
        } else {
          return arr.sort((a, b) => {
            const aDate = new Date(a[key]);
            const bDate = new Date(b[key]);
            return aDate < bDate ? 1 : (bDate < aDate ? -1 : 0);
          });
        }
      },
      sortByStatus(arr, dir, key) {
        if (dir.includes('asc')) {
          return arr.sort((a, b) => {
            return a[key] > b[key] ? 1 : (b[key] > a[key] ? -1 : 0);
          });
        } else {
          return arr.sort((a, b) => {
            return a[key] < b[key] ? 1 : (b[key] < a[key] ? -1 : 0);
          });
        }
      }
    }
  }
</script>
<style lang='scss' scoped>
  @import './../assets/sass/now-ui-kit/variables';

  .page-header {
    min-height: 25vh !important;

    .page-header-image {
      background-position: center center !important;
    }

    .container {
      text-align: left !important;

      .title {
        @media (max-width: 771px) {
          font-size: 2.25em;
        }
      }
    }
  }
  .badge {
    position: relative;
    top: -2px;
  }
  ::v-deep .dropdown-menu {
    width: 100%;
  }

  ::v-deep .el-input__inner {
    border-color: $dark-gray !important;
  }
</style>
<style lang="scss">
  .el-popper-apc {
    .popper__arrow {
      &::after {
        border-bottom-color: #ffffff !important;
      }
    }
  }
</style>
